import operate from './operate';

function isNumber(item) {
  return !!item.match(/[0-9]+/);
}

/* Learn recursive function */

const fact = (n) => {
  if (n === 0) {
    return 0;
  }
  if (n === 1) {
    return 1;
  }
  return n * fact(n - 1);
};

/**
 * Given a button name and a calculator data object, return an updated
 * calculator data object.
 *
 * Calculator data object contains:
 *   total:s      the running total
 *   next:String       the next number to be operated on with the total
 *   operation:String  +, -, etc.
 */
const calculate = (obj, buttonName) => {
  if (buttonName === 'AC') {
    return {
      total: 0,
      next: null,
      operation: null,
    };
  }

  if (isNumber(buttonName)) {
    // If there is an operation, update next
    if (obj.operation) {
      if (obj.next) {
        if (obj.next === '0') {
          return { ...obj, next: buttonName };
        }
        return { ...obj, next: obj.next + buttonName };
      }
      return { ...obj, next: buttonName };
    }
    // If there is no operation, update next and clear the value
    if (obj.next) {
      if (obj.next === '0') {
        return {
          next: buttonName,
          total: null,
        };
      }
      return {
        next: obj.next + buttonName,
        total: null,
      };
    }

    return {
      next: buttonName,
      total: null,
    };
  }

  if (buttonName === '.') {
    if (obj.next) {
      if (obj.next.includes('.')) {
        return { ...obj };
      }
      return { ...obj, next: `${obj.next}.` };
    }
    if (obj.operation) {
      return { next: '0.' };
    }
    if (obj.total) {
      if (obj.total.includes('.')) {
        return {};
      }
      return { total: `${obj.total}.` };
    }
    return { total: '0.' };
  }

  if (buttonName === '=') {
    if (obj.next && obj.operation) {
      return {
        total: operate(obj.total, obj.next, obj.operation),
        next: null,
        operation: null,
      };
    }
    // '=' with no operation, nothing to do
    return {};
  }

  if (buttonName === '+/-') {
    if (obj.next) {
      return { ...obj, next: (-1 * parseFloat(obj.next)).toString() };
    }
    if (obj.total) {
      return { ...obj, total: (-1 * parseFloat(obj.total)).toString() };
    }
    return {};
  }

  if (buttonName === '!') {
    try {
      if (obj.next) {
        return { ...obj, next: fact(parseFloat(obj.next)).toString() };
      }
      if (obj.total) {
        return { ...obj, total: fact(parseFloat(obj.next)).toString() };
      }
      return {};
    } catch (err) {
      return 'Math Error';
    }
  }

  // Button must be an operation

  // When the user presses an operation button without having entered
  // a number first, do nothing.
  // if (!obj.next && !obj.total) {
  //   return {};
  // }

  // User pressed an operation after pressing '='
  if (!obj.next && obj.total && !obj.operation) {
    return { ...obj, operation: buttonName };
  }

  // User pressed an operation button and there is an existing operation
  if (obj.operation) {
    if (obj.total && !obj.next) {
      return { ...obj, operation: buttonName };
    }

    return {
      total: operate(obj.total, obj.next, obj.operation),
      next: null,
      operation: buttonName,
    };
  }

  // no operation yet, but the user typed one

  // The user hasn't typed a number yet, just save the operation
  if (!obj.next) {
    return { ...obj, operation: buttonName };
  }

  // save the operation and shift 'next' into 'total'
  return {
    total: obj.next,
    next: null,
    operation: buttonName,
  };
};

const displayTotal = (total, next) => {
  if (total === 0 && next === null) {
    return 0;
  }

  if (total !== 0 && total !== null) {
    return total;
  }
  return '';
};

export { calculate, displayTotal };
